import React, { useState, useEffect } from 'react';

import ButtonImage from "../../SVGElements/Vector.svg"
// import { createRoot } from 'react-dom/client';

interface PointerStatus {
  x: string;
  y: string;
  xp: string;
  yp: string;
}



interface StaffCardProps {
  name: string;
  cslogin: string;
  pronouns: string;
  blurb: string;
  nation: string;
  image: string;
  altImage: string;
}

export class StaffCard extends React.Component<StaffCardProps> {
  render() {
    return (
      <div className="card-staff">
        <div className="staff-image-container">
          <img className="staff" src={this.props.image} alt={this.props.name} />
          <img className="staff-back" src={this.props.altImage} alt="alt" />
        </div>
        <div className="middle-section">
          <img className="button-image" src={ButtonImage}></img>
          <div className="name-section">
            <p className="staff-name">
              {this.props.name} ({this.props.cslogin})
            </p>
            <p className="pronouns">{this.props.pronouns}</p>
          </div>
        </div>
        <p className="staff-description">{this.props.blurb}</p>
      </div>
    );
  }
}


